var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	47975: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(8143); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	16045: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(30758); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	81772: {
		fallback: function() { return Promise.all([__webpack_require__.e(2106), __webpack_require__.e(4147)]).then(function() { return function() { return __webpack_require__(62633); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=0.13.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@fe-toolkit/utility/client/tracking-context",

	},
	74789: {
		fallback: function() { return __webpack_require__.e(8516).then(function() { return function() { return __webpack_require__(48516); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.3.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [47975,16045,81772,74789];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		81772,
		74789
	],
	"4789": [
		74789
	],
	"8792": [
		47975,
		16045
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}